import { useEffect, useState } from "react";

// Seconds since `active` turned true (0 while idle), so a long wait never reads as hung.
export default function useElapsed(active: boolean): number {
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    if (!active) { setElapsed(0); return; }
    const t0 = Date.now();
    const iv = setInterval(() => setElapsed(Math.round((Date.now() - t0) / 1000)), 1000);
    return () => clearInterval(iv);
  }, [active]);
  return elapsed;
}
